'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_JoinGeneralPracticeRequest(data) {
  this.Lapp_api_JoinGeneralPracticeRequest__f_data = null;
  this.Lapp_api_JoinGeneralPracticeRequest__f_data = data;
}
export { $c_Lapp_api_JoinGeneralPracticeRequest as $c_Lapp_api_JoinGeneralPracticeRequest };
$c_Lapp_api_JoinGeneralPracticeRequest.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_JoinGeneralPracticeRequest.prototype.constructor = $c_Lapp_api_JoinGeneralPracticeRequest;
/** @constructor */
function $h_Lapp_api_JoinGeneralPracticeRequest() {
}
export { $h_Lapp_api_JoinGeneralPracticeRequest as $h_Lapp_api_JoinGeneralPracticeRequest };
$h_Lapp_api_JoinGeneralPracticeRequest.prototype = $c_Lapp_api_JoinGeneralPracticeRequest.prototype;
$c_Lapp_api_JoinGeneralPracticeRequest.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lapp_api_JoinGeneralPracticeRequest.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-313230083), true);
});
$c_Lapp_api_JoinGeneralPracticeRequest.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_api_JoinGeneralPracticeRequest)) {
    var x = this.Lapp_api_JoinGeneralPracticeRequest__f_data;
    var x$2 = x$0.Lapp_api_JoinGeneralPracticeRequest__f_data;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lapp_api_JoinGeneralPracticeRequest.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lapp_api_JoinGeneralPracticeRequest.prototype.productArity__I = (function() {
  return 1;
});
$c_Lapp_api_JoinGeneralPracticeRequest.prototype.productPrefix__T = (function() {
  return "JoinGeneralPracticeRequest";
});
$c_Lapp_api_JoinGeneralPracticeRequest.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lapp_api_JoinGeneralPracticeRequest__f_data;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_api_JoinGeneralPracticeRequest.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "data";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lapp_api_JoinGeneralPracticeRequest(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lapp_api_JoinGeneralPracticeRequest)));
}
export { $isArrayOf_Lapp_api_JoinGeneralPracticeRequest as $isArrayOf_Lapp_api_JoinGeneralPracticeRequest };
var $d_Lapp_api_JoinGeneralPracticeRequest = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_JoinGeneralPracticeRequest, "app.api.JoinGeneralPracticeRequest", ({
  Lapp_api_JoinGeneralPracticeRequest: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lapp_api_JoinGeneralPracticeRequest as $d_Lapp_api_JoinGeneralPracticeRequest };
//# sourceMappingURL=app.api.-Join-General-Practice-Request.js.map
